export default __webpack_public_path__ + "static/media/LA-4.3b9a308f.JPG";